import { createContext } from 'react';
const TaskDataContext = /*#__PURE__*/createContext({});
export default TaskDataContext;